// extracted by mini-css-extract-plugin
export default {"button":"ButtonCategory_button__zcaA7","-active":"ButtonCategory_-active__fEd7R","-loading":"ButtonCategory_-loading__usd73","pulsate":"ButtonCategory_pulsate__LKT54"};